<template>
  <div class="editphysiquePage">
    <div @click="$router.go(-1)">
      <van-icon name="arrow-left" size="22" />
    </div>

    <div v-if="$route.query.type == 1">
      <div class="title">
        <div class="title-name">体格记录</div>
        <div class="title-font">/ {{ date }}</div>
      </div>
      <!--    身高体重-->
      <div style="display: flex; justify-content: space-between" class="height">
        <div>
          <inputBox
            title="身高"
            company="cm"
            :input-value="userHeight"
            v-model="userHeight"
            @input="getUserHeight"
          ></inputBox>
        </div>
        <div>
          <inputBox
            title="体重"
            company="kg"
            :input-value="userWeight"
            v-model="userWeight"
            @input="getUserWeight"
          ></inputBox>
        </div>
      </div>
      <!--    腰围臀围-->
      <div style="display: flex; justify-content: space-between" class="height">
        <div>
          <inputBox
            title="腰围"
            company="cm"
            :input-value="userYaowei"
            v-model="userYaowei"
            @input="getUserYaowei"
          ></inputBox>
        </div>
        <div>
          <inputBox
            title="臀围"
            company="cm"
            :input-value="userTunwei"
            v-model="userTunwei"
            @input="getUserTunwei"
          ></inputBox>
        </div>
      </div>
      <div class="BMI-box">
        <div class="BMI-box-font">BMI值=</div>
        <div class="BMI-box-font" style="color: #b4b4b4; font-weight: 500">
          {{ bmi ? bmi : "自动计算（体重÷身高²）" }}
        </div>
      </div>
      <div class="btn" @click="btnOne">保存</div>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getshiwu"
      v-if="$route.query.type == 2"
    >
      <div class="type2">
        <div class="title_search" style="display: flex; justify-content: space-between">
          <span>{{ foodType }}</span>
          <div class="searchbtn">
            <div class="btn_l">
              <div class="search-img">
                <div class="search-img-1">
                  <img src="../assets/imgs/早餐-icon1@2x.png" style="width: 100%; height: 100%" />
                </div>
              </div>
              <input
                type="text"
                placeholder="请输入食物名称"
                class="search-input"
                v-model="search_food"
                @input="editValue"
              />
            </div>
            <van-button round :loading='loading'  type="primary" class="btn_r" @click="searchfood(search_food)" size="mini" color="#d68118">
              搜索
            </van-button>
          </div>
        </div>
        <!--      饮食种类-->
        <div class="midBox" v-for="(item, index) in foodList" :key="index">
          <div class="box-items">
            <div class="item-img">
              <img :src="item.food_img" style="width: 100%; height: 100%" />
            </div>
            <div class="item-font">
              <span class="font1">{{ item.food_name }}</span>
              <span class="font2">每100克约{{ item.eng_kcal }}千卡</span>
            </div>
            <div
              class="item-add"
              @click="addItem(item.eng_kcal, item.id, item.protein, item.food_img, item.food_name, item.fat, item.cho)"
            >
              <img src="../assets/imgs/早餐-icon2@2x.png" style="width: 100%; height: 100%" />
            </div>
          </div>
        </div>

        <div class="bottom-box" :style="showType == 1 ? { 'z-index': '10' } : { 'z-index': '9999' }">
          <div class="box-info">
            <div class="box-1" @click="hasShow">
              <div class="box-1-1">{{ num }}</div>
              <img src="../assets/imgs/早餐-icon3@2x.png" style="width: 100%; height: 100%" />
              <!--                 @click="num!= 0 ? $router.push({path: 'hasRecord' , query:{id: $route.query.id , type : 4 , date : $route.query.date}}) : $toast('请先选择食物')">-->
            </div>
            <div class="box-2">合计摄入:约{{ intake.toFixed(2) }}千卡</div>
            <div class="box-3" @click="sumbit">保存</div>
          </div>
        </div>
        <!--      弹出层-->
        <van-popup
          v-model="show"
          position="bottom"
          :style="
            showType == 1
              ? {
                  height: '65%',
                  'border-radius': '16px 16px 0 0',
                  bottom: '0px',
                }
              : {
                  height: '45%',
                  'border-radius': '16px 16px 0 0',
                  bottom: '24vw',
                }
          "
        >
          <div v-if="showType == 1">
            <div class="popup">摄入量:</div>
            <div class="popup_style">
              <div class="popup_style_item" style="display: flex">
                <div class="popup_style_item_img">
                  <img :src="curImg" class="item_picture" />
                </div>
                <div>
                  <div class="font99">
                    {{ curName }}
                    <span>每100克成分</span>
                  </div>
                  <!--               <div class="font999">1</div>-->
                </div>
              </div>
              <div class="popup_info">
                <div class="info_font">
                  <div>能量</div>
                  <div>{{ Number(eng_kcal).toFixed(2) }}千卡</div>
                </div>
                <div class="info_font">
                  <div>碳水化合物</div>
                  <div>{{ Number(curtanshui).toFixed(2) }}克</div>
                </div>
                <div class="info_font">
                  <div>蛋白质</div>
                  <div>{{ Number(curdanbaizhi).toFixed(2) }}克</div>
                </div>
                <div class="info_font">
                  <div>脂肪</div>
                  <div>{{ Number(curzhifang).toFixed(2) }}克</div>
                </div>
              </div>
            </div>
            <div class="popup-mid">
              <input
                type="number"
                placeholder="请输入摄入量"
                v-model="foodnengliang"
                oninput="if(value>9999)value=9999;if(value<0)value=0"
                class="popup-mid-input"
              />
              <div class="popup-font">克</div>
            </div>
            <div class="mid-tips">本次摄入约{{ foodnengliangShow }}千卡</div>
            <div class="mid-btn" @click="baocun">保存</div>
          </div>
          <div v-else-if="showType == 2" class="hasFood">
            <div class="food_font">已选择食物:</div>
            <div class="food_box">
              <div class="food_box_item" v-for="(item, index) in curList" :key="index">
                <div class="food_item_img">
                  <img :src="item.img" style="width: 100%; height: 100%" />
                </div>
                <div style="display: flex; flex-direction: column; width: 230px">
                  <div class="font22">{{ item.name }}</div>
                  <div class="font23">摄入{{ item.weight }}克约{{ item.curDK }}千卡</div>
                </div>
                <div style="display: flex">
                  <!-- <div style="width: 32px; height: 32px">
                    <img
                      src="../assets/imgs/饮食-edit@2x.png"
                      style="width: 100%; height: 100%"
                      @click="editHasItem(item)"
                    />
                  </div> -->
                  <div style="width: 32px; height: 32px; margin-left: 12px">
                    <img
                      src="../assets/imgs/饮食-del@2x.png"
                      style="width: 100%; height: 100%"
                      @click="delHasItem(item, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-popup>
      </div>
    </van-list>
  </div>
</template>

<script>
import inputBox from "@/components/input";
import { recordEdit, shiwubiao, sumbit, GetEatDetail, recordList } from "../service/api";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "editphysique",
  components: {
    inputBox,
  },
  watch: {
    foodnengliang: {
      handler(newValue) {
        this.foodnengliangShow = ((newValue / 100) * this.eng_kcal).toFixed(2);
      },
      deep: true,
      immediate: true,
    },
    userHeight: {
      handler(newValue) {
        if (this.userHeight != "" && this.userHeight != "0") {
          this.bmi = (this.userWeight / ((this.userHeight * this.userHeight) / 10000)).toFixed(2);
        }
        if (newValue == "") {
          this.bmi = "";
        }
      },
      deep: true,
      immediate: true,
    },
    userWeight: {
      handler(newValue) {
        if (this.userWeight != "" && this.userWeight != "0") {
          this.bmi = (this.userWeight / ((this.userHeight * this.userHeight) / 10000)).toFixed(2);
        }
        if (newValue == "") {
          this.bmi = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      intake: 0,
      loading: false,
      // finished:true,
      finished: false,
      foodnengliangShow: 0,
      foodnengliang: "",
      userHeight: "",
      userWeight: "",
      userYaowei: "",
      userTunwei: "",
      searchValue: "",
      show: false,
      num: 0,
      date: "",
      bmi: "",
      foodType: "",
      search_food: "",
      foodList: [],
      limit: 10,
      page: 1,
      eng_kcal: "",
      curId: "",
      curdanbaizhi: "",
      curImg: "",
      showType: 0,
      curName: "",
      curzhifang: "",
      curtanshui: "",

      curList: [],
      // state 1=正常翻页  2=搜索时翻页
      state: 1,
    };
  },
  created() {
    // if (this.$route.params.type != 1 && this.$route.query.type != 2 && this.$route.query.type != 3 && this.$route.query.type != 4 && this.$route.query.type != 5){
    //   this.$router.push('/index')
    // }else{
    //   console.log('正确')
    // }
    //
    if (this.$route.query.foodList) {
      this.curList = JSON.parse(this.$route.query.foodList);
      this.num = this.curList.length;
      this.curList.forEach((item) => {
        this.intake += Number(item.curDK);
      });
    } else {
      GetEatDetail({ date: this.$route.query.date, type: this.$route.query.id })
        .then((res) => {
          if (res.data.list.length == 0) {
            console.log("今日没有添加饮食");
          } else {
            this.num = res.data.list.length;
            for (let i = 0; i < res.data.list.length; i++) {
              this.intake += Number(res.data.list[i].calorie);
              this.curList.push({
                curDK: res.data.list[i].calorie,
                id: res.data.list[i].food_id,
                weight: res.data.list[i].eat_weight,
                name: res.data.list[i].food_name,
                img: res.data.list[i].food_img,
                protein: Number(res.data.list[i].protein).toFixed(2),
                fat: Number(res.data.list[i].fat).toFixed(2),
                cho: Number(res.data.list[i].cho).toFixed(2),
                eng_kcal: Number(res.data.list[i].eng_kcal).toFixed(2),
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (this.$route.query.date) {
      this.date = this.$route.query.date;
      this.bmi = this.$route.query.bmi;
      this.userHeight = this.$route.query.height;
      this.userWeight = this.$route.query.weight;
      this.userYaowei = this.$route.query.waistline;
      this.userTunwei = this.$route.query.hipline;
    } else {
      this.date = this.getYYYYMMDD();
      recordList({
        date: this.dayjs().format("YYYY") + "-" + this.dayjs().format("MM"),
      }).then((res) => {
        if (
          res.data.list[Object.keys(res.data.list)[0]] ||
          JSON.stringify(res.data.list[Object.keys(res.data.list)[0]]) != "{}"
        ) {
          this.bmi = res.data.list[Object.keys(res.data.list)[0]].bmi;
          this.userHeight = res.data.list[Object.keys(res.data.list)[0]].height;
          this.userWeight = res.data.list[Object.keys(res.data.list)[0]].weight;
          this.userYaowei = res.data.list[Object.keys(res.data.list)[0]].waistline;
          this.userTunwei = res.data.list[Object.keys(res.data.list)[0]].hipline;
        }
      });
    }

    if (this.$route.query.type == 2) {
      if (this.$route.query.id == 1) {
        this.foodType = "早餐";
      } else if (this.$route.query.id == 2) {
        this.foodType = "早加餐";
      } else if (this.$route.query.id == 3) {
        this.foodType = "午餐";
      } else if (this.$route.query.id == 4) {
        this.foodType = "午加餐";
      } else if (this.$route.query.id == 5) {
        this.foodType = "晚餐";
      } else if (this.$route.query.id == 6) {
        this.foodType = "晚加餐";
      }
    }
  },
  methods: {
    delHasItem(item, index) {
      this.curList.splice(index, 1);
      this.num -= 1;
      this.intake = this.intake - item.curDK;
    },
    hasShow() {
      this.showType = 2;
      this.show = true;
    },
    sumbit() {
      if (this.curList.length == 0) {
        this.$toast("请先选择食物!");
      } else {
        let obj = {};
        obj = this.curList;
        // sumbit({
        //     'food_date': this.$route.query.date,
        //     'type': this.$route.query.id,
        //     'food_json': JSON.stringify(obj)
        // }).then(res => {
        //     this.$toast(res.msg)
        //     this.$router.push({
        //         path:'/foods',
        //         query:{
        //             date: this.$route.query.date
        //         }
        //     })
        // })

        // 跳转已选页面
        this.$router.replace({
          path: "/physique/foodsListChose",
          query: {
            date: this.$route.query.date,
            id: this.$route.query.id,
            type: this.$route.query.type,
            foodList: JSON.stringify(obj),
          },
        });
      }
    },
    baocun() {
      if (this.foodnengliang == 0 || this.foodnengliang == "") {
        this.$toast("请输入摄入量!");
      } else if (this.curList.length == 0) {
        this.curList.push({
          eng_kcal: ((this.foodnengliang / 100) * this.eng_kcal).toFixed(2),
          curDK: this.foodnengliangShow,
          id: this.curId,
          weight: this.foodnengliang,
          name: this.curName,
          protein: ((this.foodnengliang / 100) * this.curdanbaizhi).toFixed(2),
          img: this.curImg,
          fat: ((this.foodnengliang / 100) * this.curzhifang).toFixed(2),
          cho: ((this.foodnengliang / 100) * this.curtanshui).toFixed(2),
          food: {
            eng_kcal: this.eng_kcal,
            cho: this.curtanshui,
            protein: this.curdanbaizhi,
            fat: this.curzhifang,
          },
        });
        this.foodnengliang = "";
        this.intake += Number(this.foodnengliangShow);
        this.show = false;
        this.num += 1;
      } else {
        for (let i = 0; i < this.curList.length; i++) {
          if (this.curList[i].id == this.curId) {
            this.$toast("该食物已选择");
            this.show = false;
            this.foodnengliang = "";
            return;
          }
        }
        this.curList.push({
          // eng_kcal:this.eng_kcal,
          eng_kcal: ((this.foodnengliang / 100) * this.eng_kcal).toFixed(2),
          curDK: this.foodnengliangShow,
          id: this.curId,
          weight: this.foodnengliang,
          name: this.curName,
          protein: ((this.foodnengliang / 100) * this.curdanbaizhi).toFixed(2),
          img: this.curImg,
          fat: ((this.foodnengliang / 100) * this.curzhifang).toFixed(2),
          cho: ((this.foodnengliang / 100) * this.curtanshui).toFixed(2),
          food: {
            eng_kcal: this.eng_kcal,
            cho: this.curtanshui,
            protein: this.curdanbaizhi,
            fat: this.curzhifang,
          },
        });
        this.foodnengliang = "";
        this.intake += Number(this.foodnengliangShow);
        this.show = false;
        this.num += 1;
      }
      console.log("保存已选", this.curList);
    },
    searchfood() {
      this.state = this.search_sport != "" ? 2 : 1;
      this.page = 1;
      this.foodList = [];
      // this.finished = true;
      this.getshiwu();
    },
    getshiwu() {
      this.loading = true;
      if (this.state == 1) {
        // console.log('name',name)
        shiwubiao({ page: this.page, limit: this.limit })
          .then((res) => {
            if (res.data.list.length < 10) {
              this.foodList = this.foodList.concat(res.data.list);
              this.finished = true;
            } else {
              this.foodList = this.foodList.concat(res.data.list);
              this.page += 1;
              this.finished = false;
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$toast(err.message);
          });
      } else {
        shiwubiao({
          name: this.search_food,
          page: this.page,
          limit: this.limit,
        })
          .then((res) => {
            if (res.data.list.length < 10) {
              this.foodList = [...this.foodList, ...res.data.list]
              this.finished = true;
            } else {
              this.foodList = [...this.foodList, ...res.data.list]
              this.page += 1;
              this.finished = false;
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$toast(err.message);
          });
      }
    },
    // 去重复
    unique(arr) {
      return Array.from(new Set(arr));
    },
    getYYYYMMDD() {
      this.d = this.dayjs().format("DD");
      this.m = this.dayjs().format("MM");
      this.y = this.dayjs().format("YYYY");
      return this.y + "-" + this.m + "-" + this.d;
    },
    addItem(eng_kcal, id, protein, img, name, fat, cho) {
      this.showType = 1;
      this.foodnengliang = "";
      this.curId = "";
      this.curId = id;
      this.curdanbaizhi = "";
      this.curdanbaizhi = protein;
      this.curImg = "";
      this.curImg = img;
      this.curName = "";
      this.curName = name;
      this.curzhifang = "";
      this.curzhifang = fat;
      this.curtanshui = "";
      this.curtanshui = cho;
      this.eng_kcal = "";
      this.eng_kcal = eng_kcal;
      this.show = true;
    },
    editValue(e) {
      this.searchValue = e.target.value;
    },
    getUserHeight(key) {
      this.userHeight = key;
    },
    getUserWeight(key) {
      this.userWeight = key;
    },
    getUserYaowei(key) {
      this.userYaowei = key;
    },
    getUserTunwei(key) {
      this.userTunwei = key;
    },
    btnOne() {
      const obj = {
        date: this.date,
        height: this.userHeight,
        weight: this.userWeight,
        waistline: this.userYaowei,
        hipline: this.userTunwei,
        bmi: this.bmi,
      };
      recordEdit(obj)
        .then((res) => {
          this.$toast(res.msg);
          this.$router.go(-1);
        })
        .catch((error) => {
          this.$toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.editphysiquePage {
  /*width: 100%;*/
  /*height: 100%;*/
  background: #fefffe;
  padding: 16px;

  .hasFood {
    padding: 24px 16px 0 16px;

    .food_font {
      /*background: #224A91;*/
      /*width: 200px;*/
      margin-left: 8px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      color: #333333;
    }

    .food_box {
      margin-top: 4px;
      /*background: pink;*/
      width: 100%;
      height: 240px;
      padding-bottom: 80px;

      .food_box_item {
        box-sizing: border-box;
        display: flex;
        margin-top: 8px;
        width: 343px;
        height: 64px;
        background: #e9eff4;
        border-radius: 8px;
        padding-left: 12px;
        padding-right: 12px;
        padding-top: 12px;

        .font22 {
          margin-left: 12px;
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: #333333;
        }

        .font23 {
          margin-left: 12px;
          font-size: 13px;
          font-weight: 500;
          text-align: left;
          color: #666666;
        }

        .food_item_img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  /*padding-right: 16px;*/
  .title {
    display: flex;
    margin-top: 36px;
    align-items: flex-end;

    .title-name {
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      color: #222222;
      line-height: 32px;
    }

    .title-font {
      margin-left: 8px;
      font-size: 13px;
      font-weight: 400;
      text-align: left;
      color: #222222;
      line-height: 18px;
    }
  }

  .height {
    margin-top: 32px;
  }

  .btn {
    position: fixed;
    bottom: 60px;
    width: 327px;
    height: 44px;
    background: #224a91;
    border-radius: 4px;
    left: 24px;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #fefffe;
    line-height: 44px;
  }

  .BMI-box {
    width: 327px;
    height: 48px;
    background: #f5f5f5;
    border-radius: 4px;
    margin-left: 8px;
    display: flex;

    .BMI-box-font {
      line-height: 44px;
      margin-left: 16px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      color: #333333;
    }
  }

  .type2 {
    margin-bottom: 102px;

    .title_search {
      height: 32px;
      margin-top: 35px;

      span {
        font-size: 24px;
        font-weight: 600;
        text-align: left;
        color: #222222;
        line-height: 32px;
      }

      .searchbtn {
        display: flex;
        align-items: center;
        .btn_l {
          border-radius: 18px;
          display: flex;
          align-items: center;
          width: 160px;
          height: 32px;
          background: #f5f5f5;
          .search-input {
            margin-left: 8px;
            border-style: none;
            background: #f5f5f5;
            width: 100px;
            height: 20px;
            font-size: 13px;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 20px;
          }
          .search-img {
            width: 20px;
            height: 32px;
            margin-left: 12px;

            .search-img-1 {
              width: 20px;
              height: 20px;
              margin-top: 6px;
              /*margin-left: 12px;*/
            }

            /*margin-top: 6px;*/
            /*margin-left: 12px;*/
          }
        }
        .btn_r {
          width: 43px;
          margin-left: 8px;
          .van-button__text{
            font-size: 12px;
            color: #fff;
          }
        }
      }
    }
    .midBox {
      margin-top: 8px;

      .box-items {
        margin-top: 8px;
        width: 343px;
        /*height: 64px;*/
        padding: 15px 0;
        background: #f3f7fb;
        border-radius: 8px;
        display: flex;
        align-items: center;

        .item-img {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          margin-left: 12px;
        }

        .item-font {
          width: 240px;
          /*height: 40px;*/
          display: flex;
          flex-direction: column;
          margin-left: 12px;

          .font1 {
            font-size: 15px;
            font-weight: 400;
            text-align: left;
            color: #333333;
          }

          .font2 {
            font-size: 13px;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: 18px;
          }
        }

        .item-add {
          width: 24px;
          height: 24px;
        }
      }
    }

    .bottom-box {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 375px;
      height: 102px;
      background: #ffffff;
      border-radius: 15px 15px 0px 0px;
      box-shadow: 0px -3px 12px 0px rgba(0, 0, 0, 0.08);

      .box-info {
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .box-1 {
          height: 44px;
          margin-left: 16px;
          width: 44px;
          position: relative;

          .box-1-1 {
            position: absolute;
            width: 18px;
            height: 18px;
            background: #224a91;
            border: 1px solid #ffffff;
            border-radius: 50%;
            right: -6px;
            top: -2px;
            text-align: center;
            font-size: 10px;
            font-weight: 500;
            color: #ffffff;
            line-height: 18px;
          }
        }

        .box-2 {
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          max-width: 160px;
        }

        .box-3 {
          height: 44px;
          width: 120px;
          background: #224a91;
          border-radius: 4px;
          font-size: 15px;
          font-weight: 500;
          text-align: center;
          color: #fefffe;
          line-height: 44px;
          margin-right: 16px;
        }
      }
    }

    .popup_info {
      justify-content: space-between;
      display: flex;
      width: 335px;
      height: 62px;
      background: #fefffe;
      border-radius: 4px;
      margin: 12px auto 0px auto;

      .info_font {
        padding-top: 12px;
        width: 78px;
        flex-shrink: 0;
        font-size: 12px;
        text-align: center;
        color: #999999;
      }
    }

    .popup_style {
      box-sizing: border-box;
      width: 343px;
      min-height: 130px;
      background: #e9eff4;
      border-radius: 8px;
      margin-top: 12px;
      margin-left: auto;
      margin-right: auto;
      padding-top: 12px;
      padding-bottom: 5px;

      .popup_style_item {
        min-height: 40px;
        width: 320px;
        margin-left: 12px;

        .font99 {
          font-size: 15px;
          font-weight: 700;
          text-align: left;
          color: #333333;
          margin-left: 12px;
          span {
            font-size: 12px;
            color: #999;
          }
        }

        .font999 {
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #666666;
          margin-left: 12px;
        }

        .popup_style_item_img {
          width: 40px;
          height: 40px;
          .item_picture {
            display: block;
            width: 40px;
            height: 40px;
          }
        }
      }
    }

    .popup {
      margin-top: 24px;
      margin-left: 24px;
      width: 64px;
      height: 22px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      color: #333333;
    }

    .popup-mid {
      margin-top: 33px;
      height: 49px;
      margin-left: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.5px solid #eeeeee;

      .popup-mid-input {
        border-style: none;
        /*width: 144px;*/
        height: 33px;
        font-size: 24px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 33px;
      }

      .popup-font {
        font-size: 16px;
        font-weight: 400;
        text-align: right;
        color: #333333;
        line-height: 22px;
        margin-right: 24px;
      }
    }

    .mid-tips {
      margin-top: 20px;
      margin-left: 24px;
      width: 200px;
      height: 21px;
      font-size: 15px;
      font-weight: 400;
      text-align: left;
      color: #999999;
      line-height: 21px;
    }

    .mid-btn {
      margin-left: 24px;
      margin-top: 24px;
      width: 327px;
      height: 44px;
      background: #224a91;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
      color: #fefffe;
      line-height: 44px;
    }
  }

  .yixuanze {
    .font {
      /*width: 231px;*/
      margin-top: 36px;
      height: 24px;
      font-size: 18px;
      font-weight: 600;
      text-align: left;
      color: #222222;
      line-height: 24px;
    }
  }
}
</style>
